<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px" class="approveForm">
                <el-row>
                    <el-form-item label="配置编码">
                        <el-input v-model="params.code" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="配置名称">
                        <el-input v-model="params.name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="所属分类">
                        <el-select v-model="params.parentCode" clearable>
                            <el-option v-for="item in parentList" clearable :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增</el-button>
            <!-- <el-button type="primary" icon="el-icon-delete" @click="deleteConfig">删除</el-button> -->
            <span class="ps">PS：系统配置里的每个参数配置都是用的，谨慎修改！！！</span>
        </div> 
        <el-table border ref="tableRef" :data="tableData" highlight-current-row class="table-show-current" @row-dblclick="openEditDialog"  @current-change="changeCurrentRow">
            <el-table-column prop="id" align="center" label="ID" width="100"></el-table-column>
            <el-table-column prop="parentCode" align="center" label="所属分类" width="150"></el-table-column>
            <el-table-column prop="code" align="center" label="配置编码" width="200"></el-table-column>
            <el-table-column prop="name" align="center" label="配置名称" width="200"></el-table-column>
            <el-table-column prop="dataType" align="center" label="数据类型" width="100">
                <template slot-scope="scope">
                    {{dataTypeMap[scope.row.dataType]}}
                </template>
            </el-table-column>
            <el-table-column prop="dataValue" align="center" label="配置数据"></el-table-column>
            <el-table-column label="排序" width="170" align="center">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-top" @click="moveUp(scope.$index, scope.row)">上移</el-button>
                    {{scope.row.sort}}
                    <el-button type="text" icon="el-icon-bottom" @click="moveDown(scope.$index, scope.row)">下移</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="comments" align="center" label="备注"></el-table-column>
            <el-table-column label="更新时间" align="center" width="150">
                <template slot-scope="scope">
                    {{formatTimestamp(scope.row.updatedAt)}}
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10,20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog title="编辑"  :visible.sync="editDialogVisible" class="abow_dialog" @close='closeEditDialog'>
            <el-form  ref="formRef" label-width="120px" class="approveForm">
                <el-row>
                    <el-form-item label="所属分类">
                        <el-select v-model="form.parentCode" disabled>
                            <el-option v-for="item in parentList" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="配置编码">
                        <el-input v-model="form.code" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="配置名称">
                        <el-input v-model="form.name" disabled></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="数据类型">
                        <el-select v-model="form.dataType" disabled>
                            <el-option v-for="item in dataTypeList" clearable :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="配置数据">
                        <el-input v-model="form.dataValue"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input-number :min="1" v-model="form.sort"></el-input-number>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="form.comments"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <div style="display: flex;justify-content: center;margin-top:10px;">
                    <el-button type="primary" @click="onSubmit">提交</el-button>
                    <el-button @click="closeEditDialog">取消</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { sysConfigApi } from '@/api/api-sys';
export default {
    data() {
        return {
            parentList:[{code:"EMPTY",name:"上级分类"}],
            params:{
                // parentCode:"EMPTY"
            },
            pageInfo:{
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            total: 0,
            editDialogVisible:false,
            form:{},
            currentRow:null,
            
            dataTypeList:[],
            dataTypeMap:{}
        };
    },
    created() {
        let dataTypeList = [
            {label: '字符串',value: 'String'}, 
            {label: '数字',value: 'BigDecimal'},
            {label: '整数',value: 'Integer'},
        ]
        this.dataTypeList = dataTypeList;
        this.dataTypeMap = this.listToMap(dataTypeList,"value","label");
        sysConfigApi.findList({parentCode:"EMPTY"}).then(res => {
            if(res != null){
                res.unshift({code:"EMPTY",name:"上级分类"});
                this.parentList = res;
            }
        });
        this.handleSearch();
    },
    methods: {
        refreshData(){
            sysConfigApi.findPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        handleSearch() {
            this.pageInfo.pageNum = 1;
            this.refreshData();
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize= val;
            this.handleSearch();
        },
        handleCurrentChange(val){
            this.pageInfo.pageNum= val;
            this.handleSearch();
        },
        openCreate() {
            this.form={};
            this.editDialogVisible = true;
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
        },
        openEditDialog(data) {
            this.form = JSON.parse(JSON.stringify(data));
            this.editDialogVisible = true;
        },
        changeCurrentRow(val) {
            this.currentRow = val;
        },
        deleteConfig() {
            if (this.currentRow == null) {
                this.$message.error('请选择数据');
                return;
            }
            this.$confirm('确定删除配置', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                sysConfigApi.delete(this.currentRow).then(res => {
                    if (res.result) {
                        this.$message.success('删除成功');
                        this.handleSearch();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },
        closeEditDialog(){
            this.editDialogVisible = false;
            this.form = {};
        },
        onSubmit(){
            console.log(this.form.dataType);
            console.log(this.form.dataValue);
            if(this.form.dataType == "BigDecimal" && this.form.dataValue != "" && this.form.dataValue !=null && isNaN(this.form.dataValue)){
                this.$message.success("数据类型与配置数据格式不匹配");
                return;
            }
            sysConfigApi.update(this.form).then(res=>{
                if(res.result){
                    this.$message.success("保存成功");
                    this.closeEditDialog();
                    this.handleSearch();
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        moveUp(index, row){
            let data = JSON.parse(JSON.stringify(row));
            if(data.sort == null || data.sort == ""){
                data.sort = 1;
            }else{
                data.sort = data.sort-1;
            }
            sysConfigApi.update(data).then(res => {
                this.handleSearch();
            });
        },
        moveDown(index, row){
            let data = JSON.parse(JSON.stringify(row));
            if(data.sort == null || data.sort == ""){
                data.sort = 1;
            }else{
                data.sort = data.sort+1;
            }
            sysConfigApi.update(data).then(res => {
                this.handleSearch();
            });
        },
    }
}
</script>
